import { levelType } from 'json/index'

// 积分明细筛选条件
export let filterLabels = [
  {
    label: '积分时间',
    type: 'time-slot',
    value: 'integralDate',
    clearable: true,
    startName: 'startTime', // 返回数据时，开始时间的字段名
    endName: 'endTime' // 返回数据时，结束时间的字段名
  },
  {
    label: '用户等级',
    type: 'select',
    value: 'levelCode',
    clearable: true,
    options: levelType
  }
]
// 积分明细的表头
export let tableLabels = [
  {
    label: '用户名称',
    value: 'username'
  },
  {
    label: '用户手机号',
    value: 'mobile'
  },
  {
    label: '用户等级',
    value: 'levelName'
  },
  {
    label: '变动',
    value: 'content'
  },
  {
    label: '积分变动',
    value: 'value'
  },
  {
    label: '公司归属',
    value: 'branchCompanyName'
  },
  {
    label: '备注',
    value: 'remarks'
  },
  {
    label: '积分时间',
    value: 'created_date'
  }
]
